<section class="body">
  <div class="body-wrapper">
    <h1>Observaciones</h1>
    <textarea class="input-wrapper" [(ngModel)]="data.observations"></textarea>
  </div>
</section>
<footer class="footer">
  <span class="link" (click)="close()">Volver</span>
  <span size="small" class="bottom-link link" (click)="saveChanges()">Guardar</span>
</footer>